import { useUserStore } from "../../../store";
import btc from "../../../assets/assets/btc.svg";
import sat from "../../../assets/assets/sat.svg";
import styles from "./BtcUnits.module.css";

const BtcUnits = ({
  height = 18,
  style,
}: {
  height?: number;
  style?: React.CSSProperties;
}) => {
  const isSat = useUserStore((state) => state.isSat);
  // const timeoutRef = useRef<NodeJS.Timeout>();
  // const setIsSat = useUserStore((state) => state.setIsSat);
  // const [isCoolDown, setCoolDown] = useState(false);
  // const handleClick = useCallback(
  //   (event: React.MouseEvent) => {
  //     event.stopPropagation();
  //     if (!isCoolDown) {
  //       setIsSat((prev) => !prev);
  //       setCoolDown(true);

  //       timeoutRef.current = setTimeout(() => {
  //         setCoolDown(false);
  //       }, 2000);
  //     }
  //   },
  //   [isCoolDown, setIsSat]
  // );

  // useEffect(() => {
  //   return () => {
  //     if (timeoutRef.current) {
  //       clearTimeout(timeoutRef.current);
  //     }
  //   };
  // }, []);

  return (
    <img
      className={styles.component}
      // onClick={handleClick}
      src={isSat ? sat : btc}
      alt=""
      style={{ ...style, height: `${height}px` }} // Inline style to set height
    />
  );
};

export default BtcUnits;
